<ng-container *ngIf="maintenance && maintenance.machine">
  <h4><p class="text-center">Onderhoud van {{maintenance.machine.name}}</p></h4>

  <div class="card">
    <div class="card-block">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="row">
            <div class="col-md-5 col-sm-12">
              <strong>Monteur</strong>
            </div>
            <div class="col-md-7 col-md-12" *ngIf="maintenance.maintenance.user">
              &nbsp;{{maintenance.maintenance.user.name}}
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 col-sm-12">
              <strong>Type</strong>
            </div>
            <div class="col-md-7 col-sm-12" *ngIf="maintenance.machine.type === 'Compressor'">
              &nbsp;{{maintenance.machine.compressortype}}
            </div>
            <div class="col-md-7 col-sm-12" *ngIf="maintenance.machine.type !== 'Compressor'">
              &nbsp;{{maintenance.machine.type}}
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 col-md-12">
              <strong>Nummer</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.machine.serial}}
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-5 col-md-12">
              <strong>Draaiuren</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.hours}}
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-5 col-md-12">
              <strong>Draaiuren onbelast</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.nethours}}
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-5 col-md-12">
              <strong>Oliepeil</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.oillevel}}
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-4 col-sm-12">
              <strong>Drukschakelaar</strong>
            </div>
            <div class="col-md-3 col-sm-6">
              {{maintenance.machine.pressureswitch}} <ng-container *ngIf="isAdmin()">€{{maintenance.machine.pressureswitchPrice}}</ng-container>
            </div>
            <div class="col-md-5 col-sm-6">
              <div class="form-check disabled">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" [checked]="maintenance.pressureswitch" disabled>
                  vervangen
                </label>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-4 col-sm-12">
              <strong>Seperator elem</strong>
            </div>
            <div class="col-md-3 col-sm-6">
              {{maintenance.machine.seperatorelem}} <ng-container *ngIf="isAdmin()">€{{maintenance.machine.seperatorelemPrice}}</ng-container>
            </div>
            <div class="col-md-5 col-sm-6">
              <div class="form-check disabled">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" [checked]="maintenance.seperator" disabled>
                  vervangen
                </label>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type !== 'Compressor'">
            <div class="col-md-4 col-sm-12">
              <strong>Filter elem</strong>
            </div>
            <div class="col-md-3 col-sm-6">
              {{maintenance.machine.filterelem}} <ng-container *ngIf="isAdmin()">€{{maintenance.machine.filterelemprice}}</ng-container>
            </div>
            <div class="col-md-5 col-sm-6">
              <div class="form-check disabled">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" [checked]="maintenance.filterelem" disabled>
                  vervangen
                </label>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-4 col-sm-12">
              <strong>Oliefilter</strong>
            </div>
            <div class="col-md-3 col-sm-6">
              {{maintenance.machine.oilfilter}} <ng-container *ngIf="isAdmin()">€{{maintenance.machine.oilfilterPrice}}</ng-container>
            </div>
            <div class="col-md-5 col-sm-6">
              <div class="form-check disabled">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" [checked]="maintenance.oilfilter" disabled>
                  vervangen
                </label>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-4 col-sm-12">
              <strong>Luchtfilter</strong>
            </div>
            <div class="col-md-3 col-sm-6">
              {{maintenance.machine.airfilter}} <ng-container *ngIf="isAdmin()">€{{maintenance.machine.airfilterPrice}}</ng-container>
            </div>
            <div class="col-md-5 col-sm-6">
              <div class="form-check disabled">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" [checked]="maintenance.airfilter" disabled>
                  vervangen
                </label>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-4 col-sm-12">
              <strong>V-snaar</strong>
            </div>
            <div class="col-md-3 col-sm-6">
              {{maintenance.machine.vbelt}} <ng-container *ngIf="isAdmin()">€{{maintenance.machine.vbeltPrice}}</ng-container>
            </div>
            <div class="col-md-5 col-sm-6">
              <div class="form-check disabled">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" [checked]="maintenance.vbelt" disabled>
                  vervangen
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
        <div class="col-md-6 col-sm-12">
          <div class="row">
            <div class="col-md-5 col-sm-12">
              <strong>M.P.V</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.mpv}}
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-5 col-sm-12">
              <strong>Klein meteriaal</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.smallmaterials}}
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-5 col-sm-12">
              <strong>Delta P</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.deltap}}
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-5 col-sm-12">
              <strong>P onbelast</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.netp}}
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-5 col-sm-12">
              <strong>Temperatuur</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.temperature}}
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-5 col-sm-12">
              <strong>Amperage</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.amperage}}
            </div>
          </div>
          <div class="row" *ngIf="maintenance.machine.type === 'Compressor'">
            <div class="col-md-5 col-sm-12">
              <strong>Spanning</strong>
            </div>
            <div class="col-md-7 col-sm-12">
              &nbsp;{{maintenance.pressure}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12"><strong>Notities</strong></div>
        <div class="col-12">{{maintenance.notes}}</div>
      </div>
    </div>
  </div>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/pages/machinemaintenance/details/machine.maintenance.details.component.html